import { create } from "zustand";
import type { NotifyConfirmOptions } from "@/types/notify.types";

interface QueueItem {
  id: number;
  opts: NotifyConfirmOptions;
  resolve: (ok: boolean) => void;
}

interface ConfirmState {
  queue: QueueItem[];
  push: (opts: NotifyConfirmOptions, resolve: (ok: boolean) => void) => void;
  resolveAndPop: (id: number, ok: boolean) => void;
}

let nextId = 1;

export const useConfirmStore = create<ConfirmState>((set) => ({
  queue: [],
  push: (opts, resolve) =>
    set((state) => ({
      queue: [...state.queue, { id: nextId++, opts, resolve }],
    })),
  resolveAndPop: (id, ok) =>
    set((state) => {
      const item = state.queue.find((q) => q.id === id);
      item?.resolve(ok);
      return { queue: state.queue.filter((q) => q.id !== id) };
    }),
}));

export function confirm(opts: NotifyConfirmOptions): Promise<boolean> {
  return new Promise<boolean>((resolve) => {
    useConfirmStore.getState().push(opts, resolve);
  });
}
